export enum NFTFormFields {
  image = 'image',
  link = 'link'
}

export interface OpenSeaApiResp {
  assets: Record<string, any>[]
}
